/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteGuarantorRefund
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for delete guarantor refund
 *
 */
const useDeleteGuarantorRefund = (): UseMutationResult<unknown, IAxiosError, Guarantor.IDeleteGuarantorRefundRequest, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.FHIRAccountApi.deleteGuarantorRefund(model);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.guarantorInfo] });
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteGuarantorRefund;
